import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AUTH_URL } from '../../util/constants';
export const taskManagerApi = createApi({
  reducerPath: 'taskManagerApi',
  baseQuery: fetchBaseQuery({ baseUrl: AUTH_URL }),
  tagTypes: ['Tasks'],
  endpoints: (builder) => ({
    getEmployeeTimeTracking: builder.query({
      query: (employeeId: string) => ({
        url: `/tasks/${employeeId}`,
        credentials: 'include',
      }),
      providesTags: ['Tasks'],
    }),
    createTask: builder.mutation({
      query: (task) => ({
        url: '/tasks',
        method: 'POST',
        body: task,
        credentials: 'include',
      }),
      invalidatesTags: ['Tasks'],
    }),
    updateTask: builder.mutation({
      query: ({ _id: taskId, ...updates }) => ({
        url: `/tasks/${taskId}`,
        method: 'PUT',
        body: updates,
        credentials: 'include',
      }),
      invalidatesTags: ['Tasks'],
    }),
    getEmployeesTimesheet: builder.query<
      any,
      { startDate?: string; endDate?: string }
    >({
      query: ({ startDate, endDate }) => ({
        url: '/timesheet',
        params: {
          startDate,
          endDate,
        },
        credentials: 'include',
      }),
    }),
    getAllProjects: builder.query<any, void>({
      query: () => ({
        url: `/project`,
        credentials: 'include',
      }),
    }),
    getTimeUtilizationData: builder.query<any, string>({
      query: (employeeId) => ({
        url: `/utilization/${employeeId}`,
        credentials: 'include',
      }),
    }),
    createProject: builder.mutation({
      query: (project) => ({
        url: '/project',
        method: 'POST',
        body: project,
        credentials: 'include',
      }),
    }),
  }),
});

export const {
  useLazyGetEmployeeTimeTrackingQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useCreateProjectMutation,
  useGetAllProjectsQuery,
  useLazyGetTimeUtilizationDataQuery,
  
  useLazyGetEmployeesTimesheetQuery,
} = taskManagerApi;
